import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { MicroRoute } from 'routes';

import HomePage from 'pages/HomePage'; 

import LoginPage  from 'pages/access/LoginPage';
import LogoutPage from 'pages/access/LogoutPage';

import MenuCategoryForm   from 'pages/menu/MenuCategoryForm';

import MenuProductsPage from 'pages/menu/MenuProductsPage';
import MenuProductForm  from 'pages/menu/MenuProductForm';
import MenuProductPage  from 'pages/menu/MenuProductPage';
import MenuProductCostChoice from 'pages/menu/MenuProductCostChoice';
import MenuProductCostDirectForm from 'pages/menu/MenuProductCostDirectForm';
import MenuProductCostIngredientsForm from 'pages/menu/MenuProductCostIngredientsForm';
import MenuProductIngredientForm from 'pages/menu/MenuProductIngredientForm';
import MenuProductDescriptionForm from 'pages/menu/MenuProductDescriptionForm';

import BillsPage from 'pages/bills/BillsPage';
import BillPage from 'pages/bills/BillPage';
import BillNameForm from 'pages/bills/BillNameForm';

import EarningsPage from 'pages/earnings/EarningsPage';

import AccountPage from 'pages/account/AccountPage';

import NotFoundPage from 'pages/NotFoundPage';

function App(props) {
  const appStyle = {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  };

  return (
  
    <BrowserRouter>
      <div id="app" style={appStyle}>
        <Switch>
          <Route path="/" exact>
            <HomePage />
          </Route>

          <Route path="/login" exact>
            <LoginPage />
          </Route>

          <Route path="/logout" exact>
            <LogoutPage />
          </Route>

          <MicroRoute path="/menu/categories/new" exact>
            <MenuCategoryForm />
          </MicroRoute>
          
          <MicroRoute path="/menu/categories/edit/:categoryId" exact>
            <MenuCategoryForm editing={true} />
          </MicroRoute>

          <MicroRoute path="/menu/products" exact>
            <MenuProductsPage />
          </MicroRoute>

          <MicroRoute path="/menu/products/new" exact>
            <MenuProductForm />
          </MicroRoute>

          <MicroRoute path="/menu/products/:productId" exact>
            <MenuProductPage />
          </MicroRoute>

          <MicroRoute path="/menu/products/:productId/cost" exact>
            <MenuProductCostChoice />
          </MicroRoute>
          
          <MicroRoute path="/menu/products/:productId/cost/direct" exact>
            <MenuProductCostDirectForm />
          </MicroRoute>
          
          <MicroRoute path="/menu/products/:productId/ingredients" exact>
            <MenuProductCostIngredientsForm />
          </MicroRoute>

          <MicroRoute path="/menu/products/:productId/ingredients/new" exact>
            <MenuProductIngredientForm />
          </MicroRoute>

          <MicroRoute path="/menu/products/:productId/description" exact>
            <MenuProductDescriptionForm />
          </MicroRoute>

          <MicroRoute path="/bills" exact>
            <BillsPage />
          </MicroRoute>

          <MicroRoute path="/bills/:billId/name" exact>
            <BillNameForm />
          </MicroRoute>

          <MicroRoute path="/bills/:billId" exact>
            <BillPage />
          </MicroRoute>

          <MicroRoute path="/earnings" exact>
            <EarningsPage />
          </MicroRoute>

          <MicroRoute path="/account" exact>
            <AccountPage />
          </MicroRoute>
          
          <Route path="*">
            <NotFoundPage />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  )  
}

export default App;